export default __webpack_public_path__ + "static/media/2.41b67bfd.gif";